import React from "react";
// import TableComandas from "../components/TableComandas";
import AppCarteraReactTable from "../table/AppCarteraReactTable";

import Footer from "../components/Footer";

import "../css/footer.css";

const Cartera = () => {
  return (
    <>
      <AppCarteraReactTable />
      {/* <TableComandas /> */}
      <Footer />
    </>
  );
};

export default Cartera;
